import React from 'react'

interface LinkRequisitadoProjetoProps {
    projetoId: string;
    codigoPacote: string;
    descricaoLink: string
}

const LinkRequisitadoProjeto = (props: LinkRequisitadoProjetoProps) => {
    const { projetoId, codigoPacote, descricaoLink } = { ...props }
    const hotName = window.location.host;
    //const linkHref = `${hotName}/projetos/detail/${projetoId}/requisitado`
    const linkHref = `http://${hotName}/projetos/detail/${projetoId}/requisitado?codigoPacote=${codigoPacote}`
    return <a target="_blank" href={linkHref}>{descricaoLink}</a>

}


export default LinkRequisitadoProjeto;